/* Quantity Discount Offer: cart gift sync (global) + loader for the tier picker UI */
(function () {
  'use strict';
  if (window.__QDO_LOADED) return;
  window.__QDO_LOADED = true;

  var LS_KEY = 'qdo_configs_v1';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  try {
    var me = document.currentScript && document.currentScript.src;
    if (me && !customElements.get('quantity-discount-offer')) {
      var s = document.createElement('script');
      s.src = me.replace('quantity-discount-offer.js', 'quantity-discount-ui.js');
      s.defer = true;
      document.head.appendChild(s);
    }
  } catch (e) {}

  function readStoredConfigs() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function slim(c) {
    return { productId: c.productId, autoAddGifts: c.autoAddGifts, tiers: (c.tiers || []).map(function (t) { return { qty: t.qty, gifts: (t.gifts || []).map(function (g) { return g.variantId; }) }; }) };
  }
  window.__qdoStoreConfig = function (cfg) {
    try {
      var all = readStoredConfigs();
      all[String(cfg.productId)] = slim(cfg);
      localStorage.setItem(LS_KEY, JSON.stringify(all));
    } catch (e) {}
  };
  function allConfigs() {
    var map = readStoredConfigs();
    document.querySelectorAll('script[data-qdo-config]').forEach(function (el) {
      try { var c = JSON.parse(el.textContent); map[String(c.productId)] = slim(c); } catch (e) {}
    });
    return map;
  }
  function isGift(item) { return item.properties && item.properties._qd_gift; }
  function post(url, body) {
    return nativeFetch(ROOT + url, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) });
  }

  function doSync(sectionIds) {
    return nativeFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var configs = allConfigs();
      var giftLines = cart.items.filter(isGift);
      var pids = {};
      Object.keys(configs).forEach(function (k) { pids[k] = true; });
      giftLines.forEach(function (l) { pids[String(l.properties._qd_main)] = true; });

      var updates = {};
      var adds = [];
      Object.keys(pids).forEach(function (pid) {
        var cfg = configs[pid];
        var mainQty = cart.items.filter(function (i) { return String(i.product_id) === pid && !isGift(i); })
          .reduce(function (a, i) { return a + i.quantity; }, 0);
        var lines = giftLines.filter(function (l) { return String(l.properties._qd_main) === pid; });
        var desired = [];
        if (cfg) {
          if (cfg.autoAddGifts !== false && mainQty > 0) {
            var tier = null;
            cfg.tiers.forEach(function (t) { if (mainQty >= t.qty && (!tier || t.qty > tier.qty)) tier = t; });
            if (tier) desired = tier.gifts.map(function (id) { return { id: Number(id), min: tier.qty }; });
          }
        } else {
          desired = lines.filter(function (l) { return mainQty > 0 && Number(l.properties._qd_min || 0) <= mainQty; })
            .map(function (l) { return { id: l.variant_id, min: Number(l.properties._qd_min || 0) }; });
        }
        var remaining = desired.slice();
        lines.forEach(function (l) {
          var idx = -1;
          for (var i = 0; i < remaining.length; i++) { if (remaining[i].id === l.variant_id) { idx = i; break; } }
          if (idx > -1) {
            remaining.splice(idx, 1);
            if (l.quantity !== 1) updates[l.key] = 1;
          } else {
            updates[l.key] = 0;
          }
        });
        remaining.forEach(function (d) {
          adds.push({ id: d.id, quantity: 1, properties: { _qd_gift: '1', _qd_main: pid, _qd_min: String(d.min) } });
        });
      });

      if (!Object.keys(updates).length && !adds.length) return { changed: false };
      var chain = Promise.resolve();
      if (Object.keys(updates).length) chain = chain.then(function () { return post('cart/update.js', { updates: updates }); });
      if (adds.length) {
        chain = chain.then(function () {
          return post('cart/add.js', { items: adds }).then(function (r) {
            if (r.ok) return;
            return adds.reduce(function (p, item) {
              return p.then(function () { return post('cart/add.js', { items: [item] }); });
            }, Promise.resolve());
          });
        });
      }
      return chain.then(function () {
        var body = { updates: {} };
        if (sectionIds && sectionIds.length) { body.sections = sectionIds.join(','); body.sections_url = window.location.pathname; }
        return post('cart/update.js', body).then(function (r) { return r.json(); });
      }).then(function (fresh) { return { changed: true, cart: fresh }; });
    }).catch(function () { return { changed: false }; });
  }

  var syncQueue = Promise.resolve();
  function runSync(ids) {
    var run = function () { return doSync(ids); };
    syncQueue = syncQueue.then(run, run);
    return syncQueue;
  }

  function drawerSections() {
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { sections = drawer.getSectionsToRender(); } catch (e) { sections = []; }
    }
    if (!sections.length) sections = [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
    return sections;
  }

  function applySections(data) {
    var drawer = document.querySelector('cart-drawer');
    drawerSections().forEach(function (s) {
      var html = data && data[s.id];
      if (!html) return;
      var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = s.selector ? doc.querySelector(s.selector) : doc.querySelector('.shopify-section') || doc.body;
      if (source) target.innerHTML = source.innerHTML;
    });
    if (drawer) drawer.classList.toggle('is-empty', !!drawer.querySelector('.drawer__inner-empty'));
    document.dispatchEvent(new CustomEvent('qdo:cart-refreshed'));
  }

  function syncAndRefresh() {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      return runSync([]).then(function (r) { if (r && r.changed) window.location.reload(); });
    }
    var ids = drawerSections().map(function (s) { return s.id; });
    return runSync(ids).then(function (r) { if (r && r.changed && r.cart) applySections(r.cart.sections); });
  }
  window.__qdoSync = syncAndRefresh;

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
    var p = nativeFetch(input, init);
    if (!CART_RE.test(url.split('#')[0])) return p;
    return p.then(function (res) {
      if (!res.ok) return res;
      var ct = res.headers.get('content-type') || '';
      if (ct.indexOf('json') === -1) { syncAndRefresh(); return res; }
      return res.clone().json().catch(function () { return null; }).then(function (data) {
        var hasSections = data && typeof data === 'object' && data.sections && typeof data.sections === 'object';
        if (!hasSections) { syncAndRefresh(); return res; }
        var ids = Object.keys(data.sections);
        return runSync(ids).then(function (r) {
          if (!r || !r.changed || !r.cart) return res;
          var fresh = r.cart;
          if (fresh.sections) Object.keys(fresh.sections).forEach(function (k) { if (fresh.sections[k]) data.sections[k] = fresh.sections[k]; });
          if (Array.isArray(data.items) && data.item_count !== undefined) {
            var secs = data.sections;
            Object.keys(fresh).forEach(function (k) { if (k !== 'sections') data[k] = fresh[k]; });
            data.sections = secs;
          }
          var headers = new Headers(res.headers);
          headers.delete('content-length');
          return new Response(JSON.stringify(data), { status: res.status, statusText: res.statusText, headers: headers });
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAndRefresh);
  else syncAndRefresh();
})();